"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exposePxtTelemetryDataProps = exposePxtTelemetryDataProps;
function exposePxtTelemetryDataProps(props) {
  const exposedDataAttributes = {};
  for (const key in props) {
    if (key.match(/^data-pxt-telemetry|^dataPXTTelemetry[A-Z]/)) {
      exposedDataAttributes[key] = props[key];
      delete props[key];
    }
  }
  return exposedDataAttributes;
}